/* Справочники интерфейса: подписи ключей 1ПМ, мышц и частей тела по-русски, тарифы, виды спорта.
   Не данные аккаунта — только словари и настройки сервиса. */

/** Общие ключи 1ПМ вариаций движения (pm в базе упражнений) */
export const PMNAMES: Record<string, string> = {
  squat: 'Присед',
  fsquat: 'Фронт. присед',
  dead: 'Становая',
  bench: 'Жим лёжа',
  press: 'Жим стоя',
  clean: 'Взятие на грудь',
  snatch: 'Рывок',
  jerk: 'Толчок',
  rdl: 'Румынская тяга',
  ohsquat: 'Присед над головой',
};

export const BODY_RU: Record<string, string> = {
  'upper legs': 'Бёдра',
  'lower legs': 'Голени',
  back: 'Спина',
  chest: 'Грудь',
  shoulders: 'Плечи',
  'upper arms': 'Плечо (бицепс, трицепс)',
  'lower arms': 'Предплечья',
  waist: 'Пресс и кор',
  cardio: 'Кардио',
  neck: 'Шея',
};

const MUSCLE_RU: Record<string, string> = {
  abs: 'пресс', abdominals: 'пресс', 'lower abs': 'низ пресса', obliques: 'косые мышцы живота', core: 'мышцы кора',
  quads: 'квадрицепсы', quadriceps: 'квадрицепсы', hamstrings: 'бицепс бедра', glutes: 'ягодичные', adductors: 'приводящие', abductors: 'отводящие',
  'inner thighs': 'внутренняя поверхность бедра', groin: 'паховые мышцы', 'hip flexors': 'сгибатели бедра', calves: 'икры', soleus: 'камбаловидная',
  shins: 'голени', ankles: 'голеностоп', 'ankle stabilizers': 'стабилизаторы голеностопа', feet: 'стопы',
  lats: 'широчайшие', 'latissimus dorsi': 'широчайшие', 'upper back': 'верх спины', 'lower back': 'поясница', back: 'спина', spine: 'разгибатели спины',
  traps: 'трапеции', trapezius: 'трапеции', rhomboids: 'ромбовидные', 'levator scapulae': 'мышца, поднимающая лопатку',
  pectorals: 'грудные', chest: 'грудные', 'upper chest': 'верх груди', 'serratus anterior': 'передняя зубчатая',
  delts: 'дельты', deltoids: 'дельты', shoulders: 'плечи', 'rear deltoids': 'задние дельты', 'rotator cuff': 'вращательная манжета',
  biceps: 'бицепс', triceps: 'трицепс', brachialis: 'брахиалис', forearms: 'предплечья', wrists: 'запястья', 'wrist flexors': 'сгибатели запястья',
  'wrist extensors': 'разгибатели запястья', 'grip muscles': 'хват', hands: 'кисти', sternocleidomastoid: 'грудино-ключично-сосцевидная',
  'cardiovascular system': 'сердечно-сосудистая система',
};
export const muscleRu = (m: string) => MUSCLE_RU[m] || m;

/** Порядок групп в фильтре базы упражнений */
export const GROUP_ORDER = ['Ноги', 'Спина', 'Грудь', 'Плечи', 'Руки', 'Кор', 'Кардио', 'Шея', 'ТА', 'Кроссфит', 'Мобилити'];

/** Тарифы сервиса (TRN-2). Цифры — до решения OQ-8; id совпадает с trainers.plan */
/* Один тариф, цена — от числа клиентов: ступени как на лендинге (apps/api/src/lib/plans.ts, прототип data.js PLANS).
   «Пробный период» — отдельный тариф на 14 дней без ограничения по клиентам. */
export interface Tier {
  id: string;
  t: string;
  n: string;
  limit: number;
  price: number;
}
export const PLANS: Tier[] = [
  { id: 'c5', t: '5', n: 'до 5 клиентов', limit: 5, price: 490 },
  { id: 'c10', t: '10', n: '6–10 клиентов', limit: 10, price: 990 },
  { id: 'c20', t: '20', n: '11–20 клиентов', limit: 20, price: 1990 },
  { id: 'c50', t: '50', n: '21–50 клиентов', limit: 50, price: 3990 },
  { id: 'c100', t: '100', n: '51–100 клиентов', limit: 100, price: 7990 },
  { id: 'cmax', t: '100+', n: 'больше 100 клиентов', limit: 9999, price: 9990 },
];
export const TRIAL: Tier = { id: 'trial', t: '100+', n: 'Пробный период', limit: 9999, price: 0 };
export const planOf = (id: string | null | undefined): Tier => (id === TRIAL.id ? TRIAL : PLANS.find((p) => p.id === id) || PLANS[3]);
/** Лимит для подписи: без ограничения — «100+» */
export const limitLabel = (n: number) => (n >= 9999 ? '100+' : String(n));

/** Адрес клиентского приложения — для ссылки-приглашения */
export const CLIENT_URL: string = ((import.meta as any).env?.VITE_CLIENT_URL || 'https://trenergram.app').replace(/\/$/, '');
